<template>
  <div
    id="modal-download"
    v-if="sistema.length > 0"
    @click.stop="$emit('close')"
    :class="{ visible: sistema.length > 0 }"
  >
    <div id="download-card" :class="{ 'show-card': sistema.length > 0 }">
      <h1>Download {{ sistemas[sistema].label }}</h1>

      <div class="buttons">
        <a class="download-button" :href="sistemas[sistema].exe">
          <div class="content">
            <div class="title">Inslatador.exe</div>
            <div class="subtitle">(Recomendado)</div>
          </div>
        </a>

        <a class="download-button" :href="sistemas[sistema].zip">
          <div class="content">
            <div class="title">Inslatador.zip</div>
            <div class="subtitle">(Instalador compactado)</div>
          </div>
        </a>

        <a class="manuais-button" v-if="sistema === 'leitora'" href="/ajuda">
          Manuais de Apoio do SiaaE
        </a>
      </div>

      <div class="aviso">
        <h2>Atenção</h2>
        <p class="text">
          <strong>1)</strong> Este sistema utiliza a porta 1433 para Microsoft
          SQL Server, se necessário libere o firewall.
        </p>
        <p class="text">
          <strong>2)</strong> Algumas versões do Microsoft Windows não trazem o
          cliente MSSQL instalado, o que pode gerar problemas de conexão, para
          resolver o problema instale a versão mais adequada para seu sistema em
          um dos links abaixo:
        </p>
        <p class="text">
          Windows 32 bits:
          <a @click.stop="" href="/downloads/sqlnclix86.msi">sqlnclix86.msi</a>
        </p>
        <p class="text">
          Windows 32 bits:
          <a @click.stop="" href="/downloads/sqlnclix64.msi">sqlnclix64.msi</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sistema: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      sistemas: {
        cadastro: {
          label: "Cadastro",
          zip: "/downloads/insCadastro_Anglo1.zip",
          exe: "/downloads/insCadastro_Anglo1.exe",
        },
        coordenador: {
          label: "Coordenador",
          zip: "/downloads/insCoordenador_Anglo1.zip",
          exe: "/downloads/insCoordenador_Anglo1.exe",
        },
        leitora: {
          label: "Leitora SiaaE",
          zip: "/downloads/insLeitoraQR.zip",
          exe: "/downloads/insLeitoraQR.exe",
        },
      },
    };
  },
};
</script>

<style lang="scss">
#modal-download {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  align-content: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  box-sizing: border-box;

  #download-card {
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    align-content: flex-start;
    justify-content: flex-start;
    width: 100%;
    max-width: 380px;
    background-color: #fff;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22);
    box-sizing: border-box;
    transform: scale(0.5);
    opacity: 0;

    h1 {
      display: block;
      padding: 0px;
      margin: 0px;
      font-size: 28px;
      font-weight: 400;
      color: #6e6e6e;
      padding: 12px;
    }

    .buttons {
      display: block;
      box-sizing: border-box;
      width: 100%;
      padding: 0px 12px;

      a {
        text-decoration: none;
        border: none;
        outline: none;
        cursor: pointer;
      }

      .download-button {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        align-content: center;
        justify-content: center;
        height: 64px;
        background-color: #4d1224;
        width: 100%;
        margin: 0px 0px 12px 0;
        border-radius: 6px;
        overflow: hidden;
        transition: all 0.2s ease-in-out;

        .content {
          text-align: center;
          .title {
            font-size: 22px;
            font-weight: 700;
            color: white;
          }
          .subtitle {
            font-size: 14px;
            font-style: italic;
            font-weight: 400;
            color: rgba(#fff, 0.5);
          }
        }

        &:hover {
          background-color: #721833;
        }
      }

      .manuais-button {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        align-content: center;
        justify-content: center;
        text-align: center;
        height: 48px;
        font-size: 22px;
        font-weight: 700;
        background-color: #e5376e;
        color: white;
        margin: 0px 0px 12px 0;
        border-radius: 6px;
        overflow: hidden;
        transition: all 0.2s ease-in-out;

        &:hover {
          background-color: #ff4d85;
        }
      }
    }

    .aviso {
      display: block;
      background-color: #dbdbdb;
      padding: 6px;

      h2 {
        display: block;
        color: red;
        font-size: 24px;
        font-weight: 500;
        padding: 6px;
        margin: 0px;
      }

      p {
        display: block;
        font-size: 14px;
        line-height: 22px;
        font-weight: 400;
        padding: 2px 6px;
        margin: 0px;
      }
    }
  }
}

.visible {
  background-color: rgba(#000, 0.5);
  animation: fade-in 0.2s ease-in-out forwards;
}

.show-card {
  animation: zoom 0.2s ease-in-out forwards;
}

@keyframes fade-in {
  from {
    background-color: rgba(0, 0, 0, 0);
  }
  to {
    background-color: rgba(0, 0, 0, 0.5);
  }
}

@keyframes zoom {
  from {
    opacity: 0;
    transform: scale(0.5);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
